export default __webpack_public_path__ + "static/media/xapit-mini-logo.0e80f1ca.png";